import { Veo3 } from 'pages/ai/Veo/Veo3'
import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { AIImageStudio } from './image/AIImageStudio'

const AI = () => {
  return (
    <div className="flex min-h-screen justify-center">
      <div className="flex w-full justify-center">
        <Routes>
          <Route path="/create/image" element={<AIImageStudio />} />
          <Route path="/create/video" element={<Veo3 />} />
          <Route index element={<AIImageStudio />} />
        </Routes>
      </div>
    </div>
  )
}

export default AI
